/**
 * iOS Bridge Shim
 * Do not remove: required to prevent third-party iOS bridge errors in production
 * This shim prevents errors like:
 * - window.webkit.messageHandlers is undefined
 * - _AutofillCallbackHandler not defined
 *
 * These are triggered by third-party scripts (e.g. AB Tasty, GTM vendors)
 * that assume an iOS WKWebView (hybrid app environment).
 *
 * In Safari (regular browser), these iOS-specific bridge objects are not available,
 * so third-party scripts trying to access them can throw errors.
 * This shim safely defines no-op fallbacks to prevent BugSnag noise.
 */

export default () => {
  if (typeof window === "undefined") return;

  const handlerProxy = new Proxy(
    {},
    {
      get: () => ({
        postMessage: () => {
          // no-op
        },
      }),
    }
  );

  // Ensure webkit object exists
  window.webkit = window.webkit || {};

  // Only define messageHandlers if missing
  if (!window.webkit.messageHandlers) {
    window.webkit.messageHandlers = handlerProxy;
  }

  // Autofill handler safeguard
  if (typeof window._AutofillCallbackHandler === "undefined") {
    window._AutofillCallbackHandler = function () {};
  }
};
